import api from "../api"
export default {
	/**
	 *
	 * @param {number} requestID
	 * @param {Object[]} answers
	 */
	async addAudit(requestID, answers,FlowDownFromAudit,OnsiteTemplate) {
		let value = await api.post(`/audits/`, {
			request: requestID,
			answers: answers,
			FlowDownFromAudit:FlowDownFromAudit,
			OnsiteTemplate:OnsiteTemplate
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let { auditID, auditData } = value.data.data[0]
		return { auditID, auditData }
	},
	/**
	 * Gets a list of audits
	 */
	async list({
		type,
		status,
		notStatus,
		offset,
		limit,
		startDate,
		endDate,
		flowDown,
		otherParams,
	}) {
		let value = await api.get(`/audits/`, {
			params: {
				type: type,
				status: status,
				notStatus: notStatus,
				offset: isNaN(offset) ? 0 : offset,
				limit: isNaN(limit) ? undefined : limit,
				startDate: startDate,
				endDate: endDate,
				flowDown: flowDown,
				...otherParams,
			},
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},
	async get(id) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.get(`/audits/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async getOnsite(id) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.get(`/audits-onsite/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async getOnsiteSupplierView(id) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.get(`/audits-onsite-supplier-view/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async setStatus(id, statusID, comment, checklistAnswers) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		if (isNaN(parseInt(statusID))) {
			throw new Error("Status ID must be a number")
		}
		let value = await api.put(`/audits/${id}/status`, {
			status: statusID,
			comment: comment,
			checklist: checklistAnswers,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	async setExpiry(id, expiryDate) {
		if (isNaN(parseInt(id))) {
			throw new Error("ID must be a number")
		}
		let value = await api.put(`/audits/${id}/expiry`, {
			expiryDate: expiryDate,
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	async getAuditDashboard() {
		let value = await api.get(`/audits/dashboard`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async downloadAuditPDF(auditID, PDFname) {
		let value = await api.get(`/audits/${auditID}/pdf`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
			},
		})

		console.log(PDFname)

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const url = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${PDFname}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
	async downloadOnsiteAuditPDF(auditID, PDFname) {
		let value = await api.get(`/onsiteaudits/${auditID}/pdf`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
			},
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const url = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${PDFname}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},

	async downloadOnsiteSupplierAuditPDF(auditID, PDFname) {
		let value = await api.get(`/onsitesupplieraudits/${auditID}/pdf`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
			},
		})

		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}

		const url = window.URL.createObjectURL(new Blob([value.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${PDFname}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
	/**
	 * 
	 * @param {number} auditID ID of audit to be flow down'ed
	 * @returns {Promise<number>} ID of new template
	 */
	async flowDown(auditID) {
		let value = await api.post(`/audits/${auditID}/flowdown`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let templateID = value.data.data[0]
		return templateID
	},

	async onsiteList({
		type,
		status,
		notStatus,
		offset,
		limit,
		startDate,
		endDate,
		otherParams,
	}) {
		let value = await api.get(`/onsite-audits/`, {
			params: {
				type: type,
				status: status,
				notStatus: notStatus,
				offset: isNaN(offset) ? 0 : offset,
				limit: isNaN(limit) ? undefined : limit,
				startDate: startDate,
				endDate: endDate,
				...otherParams,
			},
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},

	async onsiteSupplierList({
		status,
		notStatus,
		offset,
		limit,
		startDate,
		endDate,
		otherParams,
	}) {
		let value = await api.get(`/onsite-supplier-audits/`, {
			params: {
				status: status,
				notStatus: notStatus,
				offset: isNaN(offset) ? 0 : offset,
				limit: isNaN(limit) ? undefined : limit,
				startDate: startDate,
				endDate: endDate,
				...otherParams,
			},
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return { items: data, total: value.data.metadata.pagination.totalRecords }
	},

	async getImprovements() {
		let value = await api.get(`/onsite-improvements/`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},

	async addOnsiteImprovements(auditID, items) {
		let value = await api.post(`/onsite-improvements/`, {
			auditID: auditID,
			items: items
		})
		
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async updateImprovement(id, action, filename, file) {
		let formData = new FormData()
		formData.append("id", id)
		formData.append("action", action)
		formData.append("filename", filename)
		formData.append("file", file)
		let config = {
			headers: {
				"content-type": "multipart/form-data"
			}
		}
		let value = await api.put(`/onsite-improvements/`, formData, config)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async addAuditorSchedule(auditID, scheduleItems) {
		let value = await api.post(`/onsite-schedule/`, {
			auditID: auditID,
			scheduleItems: scheduleItems
		})
		
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},

	async getSchedule(auditID) {
		let value = await api.get(`/onsite-schedule/`, {
			params: { auditID: auditID },
		})
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data
	},
}
